// Module
var code = "<div class=\"dialog-input-field dialog-input-double input\"> <input id=\"verification-code\" type=\"text\" name=\"verification_code\" placeholder=\"Verification Code\" class=\"dialog-input\"> </div>";
// Exports
module.exports = code;